import {
  ContactFormEndpointRequest,
  ContactFormEndpointResponse,
} from '../../../../generated/types';

export function submitContactForm(
  supportFetch: typeof fetch,
  body: ContactFormEndpointRequest,
): Promise<ContactFormEndpointResponse> {
  return supportFetch('/api/contact-form', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((resp) => resp.json());
}
